import { ZepIcon_default } from './chunk-SGEFWXJL.mjs';
import { jsxs, jsx } from 'react/jsx-runtime';

var PaperFillIcon = ZepIcon_default((props) => /* @__PURE__ */ jsxs("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9.5h-6.495A1.01 1.01 0 0 1 12.5 8.483V2ZM8 13a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z",
      fill: props.fill || "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M15.5 2.22a.75.75 0 0 0-.53-.22H14v5.25c0 .414.336.75.75.75H20V7a.75.75 0 0 0-.22-.53L15.5 2.22Z",
      fill: props.fill || "currentColor"
    }
  )
] }));

export { PaperFillIcon };
